"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Ghana MoMo with non-Ghanaian phone
 * Shows why Ghana MoMo requires Ghanaian phone and provides alternatives
 * 
 * This is a wrapper around CountryPhonePrompt with Ghana-specific configuration
 */
export default function GhanaPhonePrompt({ 
  onClose,
  onSwitchToStripe,
  onSwitchToBankTransfer,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const ghanaConfig = {
    title: t.ghana_phone_title,
    requiredPrefix: "+233",
    requiredCountryName: "Ghana",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={onSwitchToBankTransfer}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={ghanaConfig}
    />
  );
}
